import { useParams } from 'react-router-dom';

import { TreatmentCheckInDetails } from './details';
import { CheckInPageWrapper } from './edit';

interface TreatmentCheckInDetailsPageProps {
  matterId: string;
}

export const TreatmentCheckInDetailsPage = ({
  matterId,
}: TreatmentCheckInDetailsPageProps) => {
  const { check_in_id } = useParams<{ check_in_id: string }>();

  if (!check_in_id) {
    return <div>Check-in ID is missing.</div>;
  }

  return (
    <CheckInPageWrapper>
      <TreatmentCheckInDetails matterId={matterId} checkInId={check_in_id} />
    </CheckInPageWrapper>
  );
};
